module.exports = __webpack_public_path__ + "img/CeltCapTechCallOfTheBull.8c9e4aa4.webp";